/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import * as yup from 'yup'
import { DOC_TYPES_ALLOWED } from './EditFormConstants'

const ValidationSchema = () => {
  yup.setLocale({
    mixed: {
      required: 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR'
    },
    string: {
      max: 'FORM_VALIDATION_ERROR_MAX_LENGTH_IS_${max}'
    }
  })

  return yup.object().shape({
    id: yup.number().nullable(),
    name: yup
      .string()
      .trim()
      .max(255)
      .required()
      .default(() => ''),
    description: yup
      .string()
      .max(255)
      .nullable()
      .default(() => ''),
    documentTypesAllowed: yup
      .string()
      .oneOf(Object.values(DOC_TYPES_ALLOWED))
      .default(() => DOC_TYPES_ALLOWED.ALL),
    allowCertifiedCopies: yup
      .boolean()
      .nullable()
      .default(() => false),
    metadataTemplates: yup
      .array()
      .of(
        yup.object().shape({
          value: yup.mixed(),
          label: yup.mixed()
        })
      )
      .nullable()
      .default(() => []),
    allowedDocumentTypeTemplates: yup
      .array()
      .of(
        yup.object().shape({
          value: yup.mixed(),
          propertyType: yup.mixed(),
          label: yup.mixed()
        })
      )
      .when('documentTypesAllowed', {
        is: DOC_TYPES_ALLOWED.DEFINED_IN_CREATION,
        then: (schema: any) => schema.required()
      })
      .nullable()
      .default(() => []),
    allowedDocumentTypeTemplateIds: yup
      .array()
      .of(yup.number())
      .when('documentTypesAllowed', {
        is: DOC_TYPES_ALLOWED.DEFINED_IN_CREATION,
        then: (schema: any) => schema.required()
      })
      .nullable()
      .default(() => [])
  })
}

export default ValidationSchema
